import { Country } from '@kinomap-dev/ng-ui-lib/core';
import { ContentCountryItem } from '../types/country-viewer-repartition.type';

export function getCountryCode(
  { cnt_id }: ContentCountryItem,
  countries: Country[],
): string | undefined {
  const countryCode: string | undefined = countries
    ?.find((country: Country) => country.id === cnt_id)
    ?.code.split('-')[0]
    .toLowerCase();

  return countryCode;
}
